import { BillingSearch } from '../../shared/billing/billing-search.model';
import { BillingAmountUpdateMethod } from './billing-amount-update-method.enum';
export class BillingAmountUpdateDto extends BillingSearch {
  UpdateAmountMethod: BillingAmountUpdateMethod;
  FlatAmount: number;
  Percentage: number;
  PricingCalcID: number;
  BillingYear: number;
  RoundToWhole: boolean;

  public constructor() {
    super();

    this.OrderBy = 'Profile.ReportName:ASC';
  }
}
